module.exports = __webpack_public_path__ + "static/img/btn.2492a32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/zpserve/btn.png
// module id = Gi19
// module chunks = 1